import { AxiosResponse } from "axios";
import { axiosInstance } from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";
import { AccountType, GetAccountsResponse } from "../types/genericType";
import {
  convertToLocal,
} from "../utils/dateFormat";

export const getAccounts = async (): Promise<GetAccountsResponse> => {
  try {
    const response: AxiosResponse<GetAccountsResponse> =
      await axiosInstance.get(`${apiEndPoints.accounts}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createAccount = async (
  investor: string,
  accountName: string,
  name1099: string,
  accountType: string,
  interestType: string | null,
  rate: number | null,
  accountOpeningDate: string
): Promise<AccountType> => {
  try {
    const response: AxiosResponse<AccountType> = await axiosInstance.post(
      `${apiEndPoints.accounts}`,
      {
        investor,
        name: accountName,
        report1099Name: name1099,
        accountType,
        startDate: convertToLocal(accountOpeningDate),
        endDate: null,
        rate,
        interestType,
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const editAccount = async (
  id: number,
  investor: string,
  accountName: string,
  name1099: string,
  accountType: string,
  interestType: string | null,
  rate: number | null,
  startDate: string,
  endDate: string | null,
  sendMail: boolean,
  sendEmail: boolean,
  email: string,
  taxNumber: string
): Promise<AccountType> => {
  try {
    const response: AxiosResponse<AccountType> = await axiosInstance.put(
      `${apiEndPoints.accounts}/${id}`,
      {
        id,
        investor,
        name: accountName,
        report1099Name: name1099,
        accountType,
        startDate: startDate,
        endDate: endDate,
        rate,
        interestType,
        sendEmail,
        sendMail,
        email,
        taxNumber
      }
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getAccountById = async (id: number): Promise<AccountType> => {
  try {
    const response: AxiosResponse<AccountType> = await axiosInstance.get(
      `${apiEndPoints.accounts}/${id}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};
